import { useEffect, useState } from "react";
import Spinner from "../../../components/UI/Spinner/Spinner";
import { doExtendRentalFunctionality } from "../../../shared/api/common-api";
import ExtendChargeFinish from "./component/extend-charge-finish";
import ExtendRentalForm from "./container/extend-rental-form";
import RetrieveRentalFrom from "./container/retrieve-rental-from";
import "./rental-extension.scss";

function RentalExtension(props) {
    const { reservationInfo, closeModal, setData, onCloseAction, setMsgFromChild } = props;
    const [step, setStep] = useState(1);
    const [formValue, setFormValue] = useState(null);
    const [loader, setLoader] = useState(false);
    const [extensionResponse, setExtensionResponse] = useState(null);
    const [errorData, setErrorData] = useState(null);
    const nextStep = () => setStep((prev) => prev + 1);
    const prevStep = () => setStep((prev) => prev - 1);
    useEffect(() => {
        if (!reservationInfo) {
            return;
        }
        setFormValue({
            firstName: reservationInfo?.customerInfo?.firstName,
            lastName: reservationInfo?.customerInfo?.lastName,
            email: reservationInfo?.customerInfo?.email,
            rentalAgreementNum: reservationInfo?.rentalAgreementNum,
        });
    }, [reservationInfo]);
    const onDoExtendRentalFunctionality = async (request, requestHandleType, isNextStep = false) => {
        setErrorData(null);
        if (step === 1) {
            setMsgFromChild({
                couldTakeAction: true
            });
        }
        if (step === 1
            && extensionResponse?.rentalExtension?.firstName === formValue?.firstName
            && extensionResponse?.rentalExtension?.lastName === formValue?.lastName
            && extensionResponse?.rentalExtension?.email === formValue?.email
            && extensionResponse?.rentalExtension?.rentalAgreementNum === formValue?.rentalAgreementNum) {
            nextStep();
            return false;
        }
        setLoader(true);
        const response = await doExtendRentalFunctionality(request, requestHandleType);
        if (response) {
            if (isNextStep && response?.message && response?.message?.messageType === "SUCCESS") {
                setExtensionResponse(response);
                if (step === 2) {
                    setMsgFromChild({
                        couldTakeAction: false
                    });
                    if (reservationInfo && typeof reservationInfo?.reloadReservationData === 'function')
                        reservationInfo?.reloadReservationData();
                }
                nextStep();
            } else {
                setErrorData(response?.message);
            }
        }
        setLoader(false);
    }
    const onCloseModal = () => {
        closeModal(setData, onCloseAction);
    }
    return (
        <div>
            <ul id="progressbar">
                <li className={`${step === 1 && 'active'}`} id="account"><b>Retreive Rental</b></li>
                <li id="personal" className={`${step === 2 && extensionResponse && 'active'}`}><b>Extend Rental</b></li>
                <li id="confirm" className={`${step === 3 && extensionResponse && 'active'}`}><b>Finish</b></li>
            </ul>
            {step === 1 &&
                <RetrieveRentalFrom onRetrieveReservation={onDoExtendRentalFunctionality}
                    formValue={formValue}
                    setFormValue={setFormValue}
                    reservationInfo={reservationInfo}
                    disabled={reservationInfo && true}
                    closeModal={onCloseModal}
                    errorMsg={errorData}
                />
            }
            {step === 2 && extensionResponse &&
                <ExtendRentalForm formValue={formValue}
                    prevStep={prevStep}
                    extensionResponse={extensionResponse}
                    reservationInfo={reservationInfo}
                    authorizeRentalExtension={onDoExtendRentalFunctionality}
                    errorData={errorData}
                    closeModal={onCloseModal}
                    setLoader={setLoader}
                />}
            {step === 3 && extensionResponse && extensionResponse?.message && extensionResponse?.message?.messageType === "SUCCESS"
                && <ExtendChargeFinish formValue={formValue}
                    successMsg={extensionResponse?.message || null}
                    rentalExtension={extensionResponse?.rentalExtension}
                    closeModal={onCloseModal}
                />}
            {loader ? <Spinner /> : ""}
        </div>
    )
}

export default RentalExtension